var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg3 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 101",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "3")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M93.26,0a61.47,61.47,0,0,0-9.44.91c-3.91.63-6.61,1.36-8.24,2.24s-4.08,3-7.5,6.63A144,144,0,0,0,55.47,26c-5,7.27-9.49,14.34-13.22,21-3.34,6-6.75,12.55-10.16,19.55a34.91,34.91,0,0,0-7.48-7.23C21.32,57.11,18.18,56,15.27,56S9,57.27,5.61,59.83s-5.4,5.71-5.4,9c0,2.49,1.55,5.41,4.74,8.92a111.37,111.37,0,0,1,11.13,14,57.41,57.41,0,0,0,4.29,6.06,8.85,8.85,0,0,0,3.6,2.38,22.87,22.87,0,0,0,7,.74c4.59,0,7.71-.49,9.56-1.49a10.91,10.91,0,0,0,4.33-4.26,102.21,102.21,0,0,0,4.44-10A246.17,246.17,0,0,1,70,45.55C78.6,32,87,21.39,95,14a23.17,23.17,0,0,0,3.76-4,6.69,6.69,0,0,0,1-3.67A6.2,6.2,0,0,0,98,1.87,6.34,6.34,0,0,0,93.26,0Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/3.8b275aed.svg";
export { ForwardRef as ReactComponent };